<template>
  <div class="pdfManager">
    <ul class="PDFFilesList">
      <div v-if="!pdfFiles.length">
        <h2>You haven't uploaded any PDFs yet</h2>
        <p>Click the UPLOAD button to get going with your PDF library</p>
      </div>
      <li class="pdfList" v-for="(file, key) in pdfFiles" :key="key">
        <v-icon name="file-pdf" scale="2"></v-icon>
        <p class="fileName">{{ file.fileName.substring(0, 35) }}</p>
        <div class="button-container remove--margin-top">
          <button
            class="button-neutral"
            @click="fileToDelete(file, file.fileName)"
          >
            DELETE
          </button>
          <button class="button-neutral" @click="previewFile(file)">
            PREVIEW
          </button>
        </div>
      </li>
    </ul>
    <div class="button-container">
      <button class="button-positive" @click="showUploadModal = true">
        UPLOAD
      </button>
    </div>
    <approve-modal
      @yes="deletePDF()"
      @no="doNotDeletePDF()"
      v-if="showApproveModal"
    >
      <p slot="text">Are you sure to remove this file?</p>
    </approve-modal>
    <transition name="fadeInModal">
      <upload-pdf v-if="showUploadModal"></upload-pdf>
    </transition>
  </div>
</template>

<script>
import UploadPdf from "./UploadPdf";
import ApproveModal from "../GlobalComponents/ApproveModal";
import bus from "@/bus.js";
import { db, storage } from "@/firebase.js";

export default {
  name: "PDFManager",
  components: {
    ApproveModal,
    UploadPdf,
  },
  data() {
    return {
      fileKey: "",
      fileName: "",
      showApproveModal: false,
      showUploadModal: false,
    };
  },
  firebase() {
    return {
      pdfFiles: {
        source: db.ref(`files/${this.$customerId}/${this.$hotelId}/`),
        asObject: false,
      },
    };
  },
  created() {
    bus.$on("closeuploadPDF", () => (this.showUploadModal = false));
  },
  methods: {
    deletePDF() {
      var fullNameInStorage = this.fileKey + "." + this.fileName;
      var databaseFile = db
        .ref(`files/${this.$customerId}/${this.$hotelId}/${this.fileKey}`)
        .remove();
      var storagePromise = storage
        .ref(this.$hotelId)
        .child(fullNameInStorage)
        .delete();
      Promise.all([databaseFile, storagePromise]).then(() => {
        this.$toastEvents.push({
          type: "copy",
          title: "Deletion",
          content: "The PDF has been deleted",
          id: +new Date(),
        });
      });
      this.showApproveModal = false;
    },
    doNotDeletePDF() {
      this.showApproveModal = false;
    },
    previewFile(file) {
      window.open(file.url, "_blank");
    },
    fileToDelete(fileToDelete, fileName) {
      this.fileKey = fileToDelete[".key"];
      this.fileName = fileName;
      this.showApproveModal = true;
    },
  },
};
</script>

<style scoped>
.pdfManager {
  margin: 40px auto 0px;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  background-color: #f7f7f7;
}

.pdfList {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 10px 0px;
}

ul.PDFFilesList > li > p {
  color: #707070;
  flex-grow: 1;
  text-align: left;
  margin-left: 15px;
}
</style>
